import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InfoBar } from 'ctia-ui';
import { getDeviceTitle } from 'helpers/DeviceTypeHelper';
import { getBandsAsString } from 'helpers/Bands';
import { fetchModel } from 'actions/model';

class DeviceInfoBar extends Component {
  componentDidMount() {
    this.props.fetchModel(this.props.modelId);
  }

  render() {
    const { model } = this.props;

    if (!model.info) return null;

    const {
      vendor,
      modelnumber,
      devicetypeid,
      fccid,
      devicemodelbands
    } = model.info;

    const reqDataInfo = [
      {
        key: 'Manufacturer',
        value: vendor.name
      },
      {
        key: 'Model Name/Number',
        value: modelnumber
      },
      {
        key: 'Device Type',
        value: getDeviceTitle(devicetypeid)
      },
      {
        key: 'Bands',
        value: getBandsAsString(devicemodelbands)
      },
      {
        key: 'FCC ID',
        value: fccid
      }
    ];

    return <InfoBar show={true} data={reqDataInfo} />;
  }
}

function mapStateToProps({ model }) {
  return { model };
}

export default connect(
  mapStateToProps,
  { fetchModel }
)(DeviceInfoBar);



// WEBPACK FOOTER //
// ./src/containers/Devices/DeviceInfoBar.js